import { render } from "./ComponentP2P.vue?vue&type=template&id=405e195a&scoped=true"
import script from "./ComponentP2P.vue?vue&type=script&lang=js"
export * from "./ComponentP2P.vue?vue&type=script&lang=js"

import "./ComponentP2P.vue?vue&type=style&index=0&id=405e195a&scoped=true&lang=css"

import exportComponent from "C:\\hd\\git\\enuve\\app-cliente\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-405e195a"]])

export default __exports__